import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const NavLogin = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <a className="navbar-brand" href="/">
          <img
            src="/static/logo_potrait.png"
            alt="Logo"
            style={{ maxHeight: "100px", width: "auto" }}
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav"></div>
      </div>
    </nav>
  );
};

export default NavLogin;
